const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-user-directory', 'forum/components/UserDirectoryPage');